query GetEmailTemplateLinkEngagementStats($emailTemplateId: ID!) {
    emailTemplate(id: $emailTemplateId) {
        id
        links {
            link
            url {
                id
                fullyQualifiedUrl
            }
            numTimesSent
            numTotalClicks
            numUniqueClicks
            notifiables {
                ... on User {
                    id
                    name
                }
                ... on NotifiableAlias {
                    type
                }
            }
        }
    }
}
